import React, { createContext, Reducer, useReducer } from 'react';
import { produce } from 'immer';
import { getSessionItem, storeSessionItem } from '../../storage/SessionStorage';

export type ReferrerState = {
	referrerLabel: string;
	referrerUrl: string;
}

export type Actions = SetReferrer;

export type SetReferrer = {
	type: 'setReferrer';
	referrerLabel: string;
	referrerUrl: string;
}

const referrerLabelKey = 'referrerLabel';
const referrerUrlKey = 'referrerUrl'
const params = new URLSearchParams(window.location.search);
const referrerLabel = params.get(referrerLabelKey) || getSessionItem(referrerLabelKey) || '';
const referrerUrl = params.get(referrerUrlKey) || getSessionItem(referrerUrlKey) || '';
storeSessionItem(referrerLabelKey, referrerLabel);
storeSessionItem(referrerUrlKey, referrerUrl);

const Dispatch = createContext<React.Dispatch<Actions>>(() => {});
const State = createContext<ReferrerState>({
	referrerLabel,
	referrerUrl
});

const reducer: Reducer<ReferrerState, Actions> = (state, action) => {
	switch (action.type) {
		case 'setReferrer':
			return produce(state, (referrer) => {
				referrer.referrerLabel = action.referrerLabel;
				referrer.referrerUrl = action.referrerUrl;
			});

		default:
			throw new Error('Invalid action type in Referrer reducer');
	}
}

function Provider({ children }: { children: JSX.Element[] | JSX.Element }) {
	const [state, dispatch] = useReducer(reducer, {
		referrerLabel,
		referrerUrl
	});

	// The state and the dispatch function should be provided separately so that components that are interested
	// only in dispatching events don't need to use the state and thus re-render when the state changes
	// See here - https://reactjs.org/docs/hooks-faq.html#how-to-avoid-passing-callbacks-down
	return (
		<State.Provider value={state}>
			<Dispatch.Provider value={dispatch}>{children}</Dispatch.Provider>
		</State.Provider>
	)
}

export const Referrer = {
	State,
	Dispatch,
	Provider
};